import React from 'react';
import PropTypes from 'prop-types';
import { ActionIcon, Select } from '@mantine/core';
import { Trash } from 'tabler-icons-react';
import AppFlexbox from '../../common/AppFlexbox';
import {
  ECOM_DISCOUNT_TYPE_ENUM,
  ECOM_DISCOUNT_TYPE_LIST
} from '../../../config/constants';
import AppText from '../../common/AppText';
import CustomNumberInput from '../../common/CustomNumberInput';
import AppStack from '../../common/AppStack';

const BundleDiscountEditControls = ({
  bundleDiscount,
  title,
  onRemove,
  onChange,
  disabled,
  includeQuantitySelect,
  allowFreeGift
}) => {
  const { fkEcomDiscountType, discountAmount, minQuantity } =
    bundleDiscount || {};

  const isPercentagePricing =
    fkEcomDiscountType === ECOM_DISCOUNT_TYPE_ENUM.PERCENTAGE_DISCOUNT;

  return (
    <>
      {(title || onRemove) && (
        <AppFlexbox
          style={{
            gap: 8,
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          {title && (
            <AppText style={{ fontSize: 15, fontWeight: 700 }}>{title}</AppText>
          )}
          {onRemove && (
            <ActionIcon
              color="#C40000"
              onClick={onRemove}
              size="sm"
              variant="subtle"
            >
              <Trash color="#C40000" size={16} />
            </ActionIcon>
          )}
        </AppFlexbox>
      )}

      <AppFlexbox style={{ flex: 1, gap: 8 }}>
        {includeQuantitySelect && (
          <AppStack style={{ flex: 1 }}>
            <CustomNumberInput
              allowNegative={false}
              decimalScale={0}
              disabled={disabled}
              fixedDecimalScale
              label="Required quantity"
              onChange={(value) =>
                onChange({ ...bundleDiscount, minQuantity: Math.max(value, 1) })
              }
              value={minQuantity}
            />
          </AppStack>
        )}

        <AppStack style={{ flex: 1 }}>
          <Select
            data={ECOM_DISCOUNT_TYPE_LIST.filter((f) =>
              allowFreeGift
                ? true
                : f.value !== ECOM_DISCOUNT_TYPE_ENUM.FREE_GIFT
            )}
            disabled
            label="Type"
            onChange={(v) => {
              onChange({
                ...bundleDiscount,
                fkEcomDiscountType: v,
                discountAmount:
                  v === ECOM_DISCOUNT_TYPE_ENUM.PERCENTAGE_DISCOUNT
                    ? Math.round(discountAmount / 100) * 100
                    : discountAmount
              });
            }}
            required
            style={{ flex: 1 }}
            value={fkEcomDiscountType}
          />
        </AppStack>

        <AppStack style={{ flex: 1 }}>
          {fkEcomDiscountType !== ECOM_DISCOUNT_TYPE_ENUM.FREE_GIFT &&
            fkEcomDiscountType !== ECOM_DISCOUNT_TYPE_ENUM.NO_DISCOUNT && (
              <CustomNumberInput
                allowNegative={false}
                decimalScale={isPercentagePricing ? 0 : 2}
                disabled={disabled}
                fixedDecimalScale
                label="Amount"
                leftSection={
                  !isPercentagePricing && (
                    <AppText
                      style={{
                        fontWeight: 500,
                        color: '#666',
                        fontSize: 14
                      }}
                    >
                      $
                    </AppText>
                  )
                }
                onChange={(v) =>
                  onChange({
                    ...bundleDiscount,
                    discountAmount: v || null
                  })
                }
                placeholder="30.00"
                required
                rightSection={
                  isPercentagePricing ? (
                    <AppText
                      style={{
                        fontWeight: 500,
                        color: '#666',
                        fontSize: 14
                      }}
                    >
                      %
                    </AppText>
                  ) : (
                    <></>
                  )
                }
                style={{ flex: 1 }}
                value={discountAmount}
              />
            )}
        </AppStack>

        {!includeQuantitySelect && <AppStack style={{ flex: 1 }} />}
      </AppFlexbox>
    </>
  );
};

BundleDiscountEditControls.propTypes = {
  allowFreeGift: PropTypes.bool,
  bundleDiscount: PropTypes.object,
  disabled: PropTypes.bool,
  includeQuantitySelect: PropTypes.bool,
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  title: PropTypes.string
};

export default BundleDiscountEditControls;
